import { useEffect } from "react";
import { useAuth, usePost } from "@onefront/react-sdk";
import { buildHeaders } from "./buildHeaders";
import { useClientInformationStore } from "../../store/useClientInformationStore";

export function useGetExistingDocuments(
  searchTerm: any,
  clientId: string,
  workspaceId: string
) {
  const authData = useAuth();

  const payload = {
    workspaceId,
    pageNumber: "1",
    pageSize: "10",
    sort: "LATEST_UPLOADS",
    readByAccountant: false,
    readByCompany: false,
    urgentDocs: "",
    loggedItemId: clientId,
    startDate: "",
    endDate: "",
    filterPerYear: "",
    dateType: "DOCUMENT",
    microCategory: "",
    macroCategory: "",
    selectedCategories: {},
    invoiceNumber: "",
    checkIfUploaded: "",
    searchTerm,
  };

  const { data, loading, hasLoaded, fetch, error } = usePost(
    `documentsApi://api/v1/documents/search?`,
    payload,
    {
      lazy: true,
      headers: buildHeaders({ authData }),
    }
  );

  useEffect(() => {
    if (workspaceId) fetch();
  }, [searchTerm, workspaceId]);

  return { data, loading, hasLoaded, fetch, error };
}
